<template>
  <div>
    <b-modal
      id="modal-11"
      ok-only
      ok-title="Ок"
      modal-class="modal-primary"
      centered
      title="Корректировка таблицы"
    >
      <b-table
        :items="manual_correction"
        striped
        responsive
      >
        <template #cell(chip)="data">
          <span class="delete-cheap">
            <svg
              width="16"
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="minus"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
              class="svg-inline--fa fa-minus fa-w-14"
              @click="deleteManualCorrection(data)"
            >
              <path
                fill="currentColor"
                d="M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
                class=""
              />
            </svg>
            <span>{{ data.item.chip }}</span>
          </span>
        </template>
      </b-table>
      <b-form-input
        v-model="new_chip"
        type="number"
        no-wheel
        class="links__input"
        placeholder="Номер участника"
        style="margin-bottom: 10px"
      />
      <b-form-input
        v-model="new_field"
        type="text"
        class="links__input"
        placeholder="Название столбца"
        style="margin-bottom: 10px"
      />
      <b-form-input
        v-model="new_value"
        type="text"
        class="links__input"
        style="margin-bottom: 10px"
        placeholder="Значение"
      />
      <b-button
        variant="primary"
        @click="addCorrection()"
      >
        Добавить
      </b-button>
    </b-modal>
    <b-modal
      id="modal-10"
      ok-only
      ok-title="Ок"
      modal-class="modal-primary"
      centered
      :title="'Отсечки по чипу №' + selected_rowCode"
    >
      <b-table
        :items="selected_row"
        striped
        responsive
      >
        <template #cell(ind)="data">
          <span class="delete-cheap">
            <svg
              v-if="correction.find(e => e.ind === data.item.ind)"
              width="16"
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="minus"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
              class="svg-inline--fa fa-minus fa-w-14"
              @click="deleteCorrection(data.item.ind)"
            >
              <path
                fill="currentColor"
                d="M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
                class=""
              />
            </svg>
            <span @click="addToCorrection(data.item)">{{ data.item.ind }}</span>
            <!--                <span>Ignore</span>-->
          </span>
        </template>
      </b-table>
    </b-modal>
    <input
      ref="excel-upload-input-2"
      class=""
      type="file"
      accept=".xlsx, .xls"
      @change="handleClick"
    >
    <input
      ref="excel-upload-input"
      class="excel-upload-input"
      type="file"
      accept=".xlsx, .xls"
      @change="e => handleClick(e, true)"
    >
    <div
      class="drop"
      @drop="handleDrop"
      @dragover="handleDragover"
      @dragenter="handleDragover"
    >
      Drop excel file here or
      <b-button
        :disabled="loading"
        style="margin-left: 16px"
        variant="primary"
        @click="handleUpload"
      >
        <b-spinner
          v-if="loading"
          small
        />
        Browse
      </b-button>
    </div>
    <h4 class="mt-3">
      Онлайн трансляция из файла
    </h4>
    <b-form-group class="time-pick">
      <span>Начало старта</span>
      <flat-pickr
        v-model="start_date"
        class="form-control"
        :config="config"
      />
      Привязать результат к началу старта
      <b-form-checkbox
        v-model="related_start_time"
        class="custom-control-primary"
        name="check-view"
        switch
      />
    </b-form-group>
    <b-form-group
      label="Идентификаторы контрольных точек"
      class="mb-2"
    >
      <b-form-input
        v-model="points"
        class="links__input"
        placeholder="Идентификаторы контрольных точек"
      />
    </b-form-group>
    <b-form-group
      label="Количество контрольных точек"
      class="mb-2"
    >
      <b-form-input
        v-model.number="points_count"
        type="number"
        no-wheel
        class="links__input"
        placeholder="Количество контрольных точек"
      />
    </b-form-group>
    <b-form-group
      label="Ссылка на файл для синхронизации"
      class="mb-2"
    >
      <b-form-input
        v-model="sync_url"
        class="links__input"
        placeholder="Ссылка на файл для синхронизации"
      />
    </b-form-group>
    <b-form-group
      label="Частота обновления (секунды)"
      class="mb-2"
    >
      <b-form-input
        v-model.number="frequency"
        type="number"
        no-wheel
        class="links__input"
        placeholder="Частота обновления (секунды)"
      />
    </b-form-group>
    <b-form-group
      label="Финиш должен быть не раньше"
      class="mb-2"
    >
      <flat-pickr
        v-model="finish_min"
        class="form-control"
        :config="config"
      />
    </b-form-group>

    <b-button
      variant="primary"
      @click="toggleSync"
    >
      <b-spinner
        v-if="syncing"
        small
      />
      {{ syncing ? 'Остановить синхронизацию' : 'Запустить синхронизацию' }}
    </b-button>

    <b-button
      v-b-modal.modal-11
      style="display: block; margin-top: 10px"
      variant="primary"
    >
      Корректровки
    </b-button>
    <b-table
      :items="table_items"
      striped
      responsive
    >
      <template #cell(chip)="data">
        <span
          v-b-modal.modal-10
          @click="showAllRows(data.item.chip)"
        >{{ data.item.chip }}</span>
      </template>
    </b-table>
  </div>
</template>

<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import * as XLSX from 'xlsx'
import {
  BButton,
  BSpinner,
  BFormInput,
  BTable,
  BFormCheckbox,
  BFormGroup,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import { Russian } from 'flatpickr/dist/l10n/ru'

export default {
  name: 'ExcelUploader',
  components: {
    BButton,
    BSpinner,
    BFormInput,
    BFormGroup,
    BTable,
    flatPickr,
    BFormCheckbox,
  },
  props: {
    beforeUpload: {
      type: Function,
      default: () => () => {},
    },
    onSuccess: {
      type: Function,
      default: () => () => {},
    },
    runs: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      membersData: [],
      ignore_list: [],
      selected_rowCode: null,
      selected_row: null,
      interval_id: null,
      table_items: [],
      all_rows: [],
      start_date: '2022-09-10T07:00:00.000Z',
      related_start_time: false,
      loading: false,
      syncing: false,
      sync_url: 'http://127.0.0.1:8887/3.csv',
      frequency: 30,
      points_count: 15,
      points: 'TRZT1,TRZT2,TRZT3',
      finish_min: '',
      excelData: {
        header: null,
        results: null,
      },
      correction: [],
      new_chip: '',
      new_field: '',
      new_value: '',
      manual_correction: [],
      config: {
        allowInput: true,
        altFormat: 'd.m.Y H:i',
        altInput: true,
        enableTime: true,
        dateFormat: 'Z',
        locale: Russian, // locale for this instance only
      },
    }
  },
  mounted() {
    if (localStorage.correction) {
      this.correction = JSON.parse(localStorage.getItem('correction'))
    }
    // if(localStorage.ignore_list){
    //     this.ignore_list = JSON.parse( localStorage.getItem('ignore_list'))
    // }
    if (localStorage.manual_correction) {
      this.manual_correction = JSON.parse(
        localStorage.getItem('manual_correction'),
      )
    }
  },
  created() {},
  methods: {
    // addToIgnore(item) {
    //   this.ignore_list.push({
    //     chip: this.selected_rowCode,
    //     ind: item.ind,
    //     stamp: item,
    //   })
    //   localStorage.setItem('ignore_list', JSON.stringify(this.ignore_list))
    // },
    addCorrection() {
      if (this.new_value && this.new_field && this.new_chip) {
        this.manual_correction.push({
          chip: this.new_chip,
          field: this.new_field,
          value: this.new_value,
        })
        localStorage.setItem(
          'manual_correction',
          JSON.stringify(this.manual_correction),
        )
      }
    },
    deleteManualCorrection(ind) {
      this.manual_correction.splice(ind.index, 1)
      localStorage.setItem(
        'manual_correction',
        JSON.stringify(this.manual_correction),
      )
    },
    deleteCorrection(ind) {
      const item = this.correction.findIndex(e => e.ind === ind)

      this.correction.splice(item, 1)

      localStorage.setItem('correction', JSON.stringify(this.correction))
    },
    addToCorrection(item) {
      // todo: сделать модальное окно, вместо prompt
      const circle = prompt('Введите номер отрезка')
      if (circle) {
        this.correction.push({
          chip: this.selected_rowCode,
          circle,
          ind: item.ind,
          stamp: item,
        })
      }

      localStorage.setItem('correction', JSON.stringify(this.correction))
    },
    showAllRows(row) {
      this.selected_rowCode = row
      this.selected_row = this.all_rows[row]
    },
    fillShift(pointFrom, pointTo) {
      const arr = []
      const points = this.points.split(',')
      let indFrom = points.findIndex(e => e === pointFrom)
      indFrom = indFrom === points.length - 1 ? 0 : indFrom + 1
      const indTo = points.findIndex(e => e === pointTo)

      while (indFrom !== indTo) {
        arr.push('-')
        indFrom = indFrom === points.length - 1 ? 0 : indFrom + 1
      }

      return {
        arr,
        indTo,
      }
    },
    async startParsing() {
      const points = this.points.split(',')
      const members = {}

      // Чтение и обработка файла
      const fileData = (await this.readFileFromUrl(this.sync_url))
        .split('\n')
        .map(line => line.split(';'))

      // Обработка строк файла
      fileData.forEach((fileRow, rowIndex) => {
        const obj = {
          ind: rowIndex,
          time: fileRow[1],
          start_timestamp: this.membersData[fileRow[0]]?.start_timestamp,
          timestamp: this.$moment(fileRow[1], 'DD.MM.YYYY HH:mm:ss').format('x'),
          point: fileRow[2],
        }

        if (Array.isArray(members[fileRow[0]])) {
          members[fileRow[0]].push(obj)
        } else {
          members[fileRow[0]] = [obj]
        }
      })

      this.all_rows = members
      let membersResult = []

      // Обработка данных участников
      this.membersData.forEach(member => {
        const memberRecords = members[member.chip]
        let memberResult

        if (memberRecords) {
          const run = this.runs.find(r => r.name === member.start_date)
          const startDateStart = run
            ? this.$moment(run.time)
            : memberRecords[0].start_timestamp

          // Поиск финишной записи
          const finishRecord = memberRecords
            .filter(record => ['BACKUP', 'FINISH'].includes(record.point))
            .filter(
              record => startDateStart < record.timestamp
                && this.$moment(this.finish_min).format('x') <= record.timestamp,
            )
            .sort((a, b) => a.timestamp - b.timestamp)[0]

          // Обработка кругов
          const tempCircles = memberRecords
            .filter(
              record => points.includes(record.point)
                && startDateStart < record.timestamp,
            )
            .filter(
              (record, index, arr) => !(arr[index - 1] && arr[index - 1].point === record.point),
            )

          let circles = []
          let pointIndex = 0

          tempCircles.forEach((record, index) => {
            const correction = this.correction.find(
              item => item.chip === record.chip && +item.circle === index + 1,
            )

            if (correction) {
              circles.push(
                this.$moment
                  .duration(
                    correction.stamp.timestamp - startDateStart,
                    'milliseconds',
                  )
                  .format('HH:mm:ss'),
              )
              pointIndex = pointIndex === points.length - 1 ? 0 : pointIndex + 1
            } else {
              if (record.point === points[pointIndex]) {
                circles.push(
                  this.$moment
                    .duration(record.timestamp - startDateStart, 'milliseconds')
                    .format('HH:mm:ss'),
                )
              } else {
                const shiftResult = this.fillShift(
                  tempCircles[index - 1]
                    ? tempCircles[index - 1].point
                    : points[points.length - 1],
                  record.point,
                )
                circles = circles.concat(shiftResult.arr)
                pointIndex = shiftResult.indTo
                circles.push(
                  this.$moment
                    .duration(record.timestamp - startDateStart, 'milliseconds')
                    .format('HH:mm:ss'),
                )
              }
              pointIndex = pointIndex === points.length - 1 ? 0 : pointIndex + 1
            }

            // Форматирование времени
            circles[circles.length - 1] = circles[circles.length - 1].length === 5
              ? `00:${circles[circles.length - 1]}`
              : circles[circles.length - 1]
          })

          memberResult = {
            chip: member.chip,
            circles,
            finish: finishRecord
              ? this.$moment
                .duration(finishRecord.timestamp - startDateStart, 'milliseconds')
                .format('HH:mm:ss')
              : '-',
          }

          // Дополнительное форматирование времени финиша
          memberResult.finish = memberResult.finish.length === 5
            ? `00:${memberResult.finish}`
            : memberResult.finish
        } else {
          memberResult = {
            chip: member.chip,
          }
        }

        if (!memberResult.finish) {
          memberResult.finish = '-'
        }

        // Подготовка данных участника
        const memberData = {};
        [
          'name',
          'surname',
          'group',
          'team',
          'number',
          'distance',
          'sex',
        ].forEach(key => {
          memberData[key] = member[key]
        })

        membersResult.push({
          ...memberData,
          place: 0,
          ...memberResult,
        })
      })

      // Форматирование результатов
      membersResult = membersResult.map(result => {
        const circlesData = {}
        let circleIndex = 0
        let remainingCircles = +this.points_count

        while (remainingCircles) {
          if (result.circles && result.circles[circleIndex]) {
            circlesData[`circle${circleIndex + 1}`] = result.circles[circleIndex]
          } else {
            circlesData[`circle${circleIndex + 1}`] = '-'
          }
          circleIndex += 1
          remainingCircles -= 1
        }

        return {
          ...result,
          circles: '',
          ...circlesData,
        }
      })

      // Применение ручных корректировок
      this.table_items = membersResult.map(resultItem => {
        const corrections = this.manual_correction.filter(
          correction => correction.chip === resultItem.number,
        )

        if (corrections.length > 0) {
          corrections.forEach(correction => {
            // eslint-disable-next-line no-param-reassign
            resultItem[correction.field] = correction.value
          })
        }
        return resultItem
      })

      // Подготовка данных для загрузки
      const resultsToUpload = this.table_items.map(uploadItem => {
        const uploadCircles = {}
        let circleIndex = 0
        let remainingCircles = +this.points_count

        while (remainingCircles) {
          uploadCircles[`circle${circleIndex + 1}`] = uploadItem[`circle${circleIndex + 1}`]
          circleIndex += 1
          remainingCircles -= 1
        }

        return {
          name: `${uploadItem.name} ${uploadItem.surname}`,
          team: uploadItem.team,
          body_number: uploadItem.number,
          place: uploadItem.place,
          group: uploadItem.group,
          sex: uploadItem.sex,
          distance: uploadItem.distance,
          ...uploadCircles,
          result: uploadItem.finish,
        }
      })

      // Сортировка и расчёт мест
      resultsToUpload
        .filter(
          result => result.result && ['-', 'DNF', 'DNS', 'DSQ'].indexOf(result.result) === -1,
        )
        .sort(
          (a, b) => a.result.replaceAll(':', '') - b.result.replaceAll(':', ''),
        )
        .forEach((result, index) => {
          // eslint-disable-next-line no-param-reassign
          result.place = index + 1
        })

      // Генерация финальных данных
      this.generateData({
        results: resultsToUpload,
      })
    },
    async toggleSync() {
      if (this.membersData.length === 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Предупреждение',
            icon: 'BellIcon',
            text: 'Не загружен файл с информацией об участниках',
            variant: 'warning',
          },
        })
        return false
      }
      this.syncing = !this.syncing
      clearInterval(this.interval_id)
      if (this.syncing) {
        this.startParsing()
        this.interval_id = setInterval(this.startParsing, this.frequency * 1000)
      }

      return true
    },
    async readFileFromUrl(url) {
      const response = await fetch(url)
      return response.text()
    },
    generateData({ header, results }) {
      this.excelData.header = header
      this.excelData.results = results
      if (this.onSuccess) {
        this.onSuccess(this.excelData)
      }
    },
    handleDrop(e) {
      e.stopPropagation()
      e.preventDefault()

      if (this.loading) return false

      const { files } = e.dataTransfer
      if (files.length !== 1) {
        this.showToast('Поддерживается загрузка только одного файла')
        return false
      }

      const rawFile = files[0]
      if (!this.isExcel(rawFile)) {
        this.showToast('Поддерживаемые форматы: .xlsx, .xls, .csv')
        return false
      }

      this.upload(rawFile)
      return true // Успешное выполнение
    },
    showToast(text) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Предупреждение',
          icon: 'BellIcon',
          text,
          variant: 'warning',
        },
      })
    },
    handleDragover(e) {
      e.stopPropagation()
      e.preventDefault()
      e.dataTransfer.dropEffect = 'copy'
    },
    handleUpload() {
      this.$refs['excel-upload-input'].click()
    },
    handleClick(e, flag = false) {
      const { files } = e.target
      const rawFile = files[0] // only use files[0]
      if (!rawFile) return
      this.upload(rawFile, flag)
    },
    upload(rawFile, flag) {
      this.$refs['excel-upload-input'].value = null // fix can't select the same excel
      if (!this.beforeUpload) {
        this.readerData(rawFile, flag)
        return
      }
      const before = this.beforeUpload(rawFile)
      if (before) {
        this.readerData(rawFile, flag)
      }
    },
    readerData(rawFile, flag) {
      this.loading = true
      return new Promise(resolve => {
        const reader = new FileReader()
        reader.onload = e => {
          const data = e.target.result
          const workbook = XLSX.read(data, { type: 'array' })
          const firstSheetName = workbook.SheetNames[0]
          const worksheet = workbook.Sheets[firstSheetName]
          const header = this.getHeaderRow(worksheet)
          const results = XLSX.utils.sheet_to_json(worksheet, {
            header,
            raw: false,
          })
          results.shift()
          results.shift()
          if (flag) {
            this.generateData({ header, results })
          } else {
            const newResults = []
            results.forEach(member => {
              newResults[member.chip] = {
                ...member,
                start_timestamp: this.$moment(
                  `${member.start_date} ${member.start_time}`,
                  'DD.MM.YYYY HH:mm:ss',
                ).format('x'),
              }
            })
            this.membersData = newResults
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Уведомление',
                icon: 'BellIcon',
                text: 'Данные об участниках загружены',
                variant: 'success',
              },
            })
          }
          this.loading = false
          resolve()
        }
        reader.readAsArrayBuffer(rawFile)
      })
    },
    getHeaderRow(sheet) {
      const headers = []
      const range = XLSX.utils.decode_range(sheet['!ref'])
      let C
      const R = range.s.r
      /* start in the first row */
      for (C = range.s.c; C <= range.e.c; ++C) {
        /* walk every column in the range */
        const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })]
        /* find the cell in the first row */
        let hdr = `UNKNOWN ${C}` // <-- replace with your desired default
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell)
        headers.push(hdr)
      }
      return headers
    },
    isExcel(file) {
      return /\.(xlsx|xls|csv)$/.test(file.name)
    },
  },
}
</script>

<style scoped lang="scss">
.excel-upload-input {
  display: none;
  z-index: -9999;
}

.drop {
  border: 2px dashed #bbb;
  width: 600px;
  height: 160px;
  line-height: 160px;
  margin: 0 auto;
  font-size: 24px;
  border-radius: 5px;
  text-align: center;
  color: #bbb;
  position: relative;
}
.delete-cheap {
  display: flex;
  svg {
    width: 10px;
    margin-right: 5px;
    transition: 0.3s;
    &:hover {
      cursor: pointer;
      transform: scale(1.1);
    }
  }
}
</style>
